export interface Account {
  id?: string;
  number: string;
  swift?: string;
  iban?: string;
  bsbCode?: string;
  routingNumber?: string;
  fw?: string;
  type: AccountType;
  vinnovaStatus?: VinnovaStatus;
  worksiteId?: string;
  companyId?: string;
  country: string;
  countryName?: string;
  existOnSameCompany?: boolean;
  companyName?: string;
}

export enum AccountType {
  PlusGiro,
  BankGiro,
  Utlandskonto,
}

export enum VinnovaStatus {
  New = -1,
  Unverified,
  Verified,
  Blocked,
  Obsolete,
}
